export default __webpack_public_path__ + "static/media/doctor.270eb4c6.png";